<!-- eslint-disable vue/multi-word-component-names -->
<script>
  export default {
    props: {
      time: {
        type: String || null,
        required: true,
        default: '',
      },
    },
    data() {
      return {
        duration: 0,
        timer: 0,
      };
    },
    computed: {
      ISOTimer: function () {
        return this.convertToISOTime();
      },
    },
    methods: {
      convertToDuration: function (timeString) {
        const isMoreThanDay = timeString.split(':')[0]?.indexOf('.') > -1;
        if (isMoreThanDay) {
          const [dayWithHours, minutes, seconds] = timeString.split(':').map(Number);
          const [day = 0, hours = 0] = dayWithHours?.toString().split('.').map(Number);
          const intSeconds = Math.round(seconds);
          return day * 24 * 3600 + hours * 3600 + minutes * 60 + intSeconds;
        } else {
          const [hours, minutes, seconds] = timeString.split(':').map(Number);
          const intSeconds = Math.round(seconds);
          return hours * 3600 + minutes * 60 + intSeconds;
        }
      },
      convertToISOTime: function () {
        const hours = Math.floor(this.duration / 3600);
        const minutes = Math.floor((this.duration % 3600) / 60);
        const seconds = this.duration % 60;
        return `${hours?.toString()?.padStart(2, '0')}:${minutes
          ?.toString()
          ?.padStart(2, '0')}:${seconds?.toString()?.padStart(2, '0')}`;
      },
      timeCountUp: function () {
        this.duration = this.convertToDuration(this.time);
        this.timer = setInterval(() => {
          this.duration += 1;
        }, 1000);
      },
      clearTimer: function () {
        clearInterval(this.timer);
        this.timer = null;
      },
    },
    // mounted() {
    //     this.timeCountUp()
    // },
    watch: {
      time: {
        handler(newVal) {
          this.clearTimer();
          if (newVal) {
            this.timeCountUp();
          }
        },
        immediate: true,
      },
    },
    beforeDestroy() {
      this.clearTimer();
    },
    beforeUnmount() {
      this.clearTimer();
    },
  };
</script>
<template>
  <div>
    <div v-if="time">
      {{ ISOTimer }}
    </div>
    <div v-else>-</div>
  </div>
</template>
